<template>
    <ProfileOptionSelector :model="'university'" :nextRoute="() => `CollegePage`" />
</template>

<script>
export default {
    name: 'University',
}
</script>
